export default [
  {
    type: "title",
    title: "MPai数据科学平台(以下简称“MPai”)隐私保护指引",
    subTitle: "更新日期：2020年8月6日  生效日期：2020年8月6日"
  },
  { type: "divers" },
  {
    type: "context",
    context:
      "您的个人信息安全对我们来说至关重要。一直以来，MPai都致力于为每位用户提供更安全的互联网环境。我们将依据《中华人民共和国网络安全法》、《信息安全技术个人信息安全规范》（GB/T35273-2017）以及其他相关法律法规和技术规范收集和使用您的个人信息，以帮助我们向您提供更优质的MPai产品或服务。《MPai隐私保护指引》（以下简称“本指引”）以透明地呈现我们收集和使用您个人信息的情况，以及您享有的对个人信息的控制权。我们承诺会对您的个人信息和其它数据进行严格保密，并严格按照本指引所阐述的内容处理您的个人信息。我们会根据您的同意和其它可处理您个人信息的法律依据收集、使用、存储、共享和转移您的个人信息。"
  },
  {
    type: "titleAndcontext",
    title: "以下是《MPai隐私保护指引》的要点说明：",
    context:
      "1. 为帮助您注册并使用MPai产品或服务，我们可能收集与提供服务相关的个人信息，您有权拒绝或撤回授权；<br/>2. 您可以访问、更正、删除您的个人信息，改变您授权同意的范围，注销您的帐号，我们为您提供了行使这些权利的途径<br/>3. 我们采取了互联网业内标准的技术措施和数据安全措施来保护您的个人信息安全。<br/>4. 除非再次征得您的同意，我们不会将您的个人信息用于本指引未载明的其他目的。<br/>5. 当您对本指引有任何疑问，可以和我们进一步联系与咨询。<br/>6. 请确认您为 18 岁以上人士。"
  },
  {
    type: "titleAndcontext",
    title: "目录",
    context:
      "1.我们处理个人信息的法律依据；<br/>2.我们如何收集和使用您的个人信息；<br/>3.我们可能分享、转让和披露的信息；<br/>4.我们如何保护您的个人信息；<br/>5.如何管理您的信息；<br/>6.我们如何使用Cookie或同类技术；<br/>7.未成年人保护；<br/>8.通知与修订；<br/>9.联系我们。"
  },
  {
    type: "titleAndcontext",
    title: "1.我们处理个人信息的法律依据：",
    context:
      "如果您是中华人民共和国大陆地区的用户，我们将依据《中华人民共和国网络安全法》、《信息安全技术 个人信息安全规范》（GB/T 35273-2017）以及其他相关法律法规收集和使用您的个人信息，为您提供MPai产品或服务。我们通常只会在征得您同意的情况下收集您的个人信息。在某些情况下，我们可能还会基于法律义务或者履行合同之必需向您收集个人信息，或者可能需要个人信息来保护您的重要利益或其他人的利益。"
  },
  {
    type: "titleAndcontext",
    title: "2.我们如何收集和使用您的个人信息：",
    context:
      "我们会遵循正当、合法、必要的原则，出于本指引所述的以下目的，收集和使用您在使用服务过程中主动提供或因使用MPai产品或服务而产生的个人信息。如果我们要将您的个人信息用于本指引未载明的其它用途，或基于特定目的将收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。"
  },
  {
    type: "titleAndcontext",
    title: "2.1您注册成为我们的用户时",
    context:
      "1.您注册并登录MPai账号时，需要向我们提供以下信息：账号名称（可选）、头像（可选）、邮箱（可选）和手机号码。您提供上述信息并同意《MPai服务条款》和本指引后，您可以使用MPai的核心业务功能。如果您选择不提供为实现MPai核心业务功能的必备信息或使用其中某类功能的必备信息，将导致我们无法为您提供功能。<br/>2.在您注册MPai账号时，我们会需要您提供手机号码进行验证，如您拒绝提供手机号码进行验证，将导致注册不成功，因此无法使用MPai的任何功能。"
  },
  {
    type: "titleAndcontext",
    title: "2.2 我们可能从第三方间接获取您的个人信息",
    context:
      "1.您使用第三方账号（微信）登录MPai时，可以选择授权MPai在符合相关法律要求的前提下读取并获得您在该第三方平台上登记、公布、记录的公开信息（包括昵称、头像）。<br/>2.MPai需要您授权从第三方获取上述信息是为了记住您作为MPai用户的登录身份，以向您提供更优质的产品或服务。我们仅会在您的授权同意的范围内收集并使用您的个人信息。在您使用第三方帐号注册或登录后，您的第三方帐号将会与MPai帐号进行绑定，但您可以在账号设置中选择关闭，进行取消帐号绑定。"
  },
  {
    type: "titleAndcontext",
    title: "2.3 敏感信息",
    context:
      "在向MPai提供任何属于敏感信息的个人信息前，请您清楚考虑该等提供是恰当的并且同意您的个人敏感信息可按本指引所述的目的和方式进行处理。<br/>我们会在得到您的同意后收集和使用您的敏感信息以实现与MPai业务相关的功能，并允许您对这些敏感信息的收集与使用做出不同意的选择，但是拒绝使用这些信息会影响您使用相关功能。"
  },
  {
    type: "titleAndcontext",
    title: "2.4 征得授权同意的例外",
    context:
      "根据相关法律法规的规定，在以下情形中，我们可以在不征得您的授权同意的情况下收集、使用一些必要的个人信息："
  },
  {
    type: "context",
    title: "",
    context:
      "a. 与国家安全、国防安全直接相关的；<br/>b. 与公共安全、公共卫生、重大公共利益直接相关的；<br/>c. 与犯罪侦查、起诉、审判和判决执行等直接相关的；<br/>d. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br/>e. 所收集的个人信息是您自行向社会公众公开的；<br/>f. 从合法公开披露的信息中收集到您的个人信息，如从合法的新闻报道、政府信息公开等渠道；<br/>g. 根据您的要求签订和履行合同所必需的；<br/>h. 用于维护MPai的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br/>i. 法律法规规定的其他情形。"
  },
  {
    type: "titleAndcontext",
    title:
      "2.5 如果您对我们收集和使用您的个人信息的法律依据有任何疑问或需要提供进一步的信息，请通过「联系我们」一节提供的联系方式与我们联系。",
    context: ""
  },
  {
    type: "titleAndcontext",
    title: "3.我们可能分享、转让和披露的信息"
  },
  {
    type: "titleAndcontext",
    title:
      "3.1我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：",
    context:
      "1.事先获得您的明确授权或同意：获得您的明确同意后，我们会与其他方共享您的个人信息；<br/>2.在法定情形下的共享：根据适用的法律法规、法律程序、政府的强制命令或司法裁定而需共享您的个人信息；<br/>3.在法律要求或允许的范围内，为了保护MPai及其用户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方；<br/>4.与我们的关联公司共享：您的个人信息可能会在我们的关联公司之间共享。我们只会共享必要的个人信息，且这种共享受本指引所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意；<br/>5.与授权合作伙伴共享：为了向您提供更完善、优质的产品和服务，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，MPai向您寄送礼品时，MPai需要与物流服务提供商共享您的个人信息才能安排寄送。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。同时，我们会与合作伙伴签署严格的保密协定，要求他们按照我们的说明、本指引以及其他任何相关的保密和安全措施来处理您的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。如果您拒绝我们的合作伙伴在提供服务时收集为提供服务所必须的个人信息，将可能导致您无法在MPai中使用该第三方服务。"
  },
  {
    type: "titleAndcontext",
    title: "3.2 转让",
    subTitle:
      "除非获取您的明确同意，我们不会将您的个人信息转让给任何公司、组织或个人。",
    context:
      "如果发生合并、收购或破产清算，将可能涉及到个人信息转让，此种情况下我们会要求新的持有您个人信息的公司、组织继续受本指引的约束。如果本指引中约定的个人信息的收集、处理方式发生任何改变，该公司、组织将重新向您征求授权同意。"
  },
  {
    type: "titleAndcontext",
    title: "3.3 公开披露",
    subTitle: "除非获取您的明确同意，我们不会公开披露您的个人信息。",
    context:
      "基于法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会向有权机关披露您的个人信息。但我们保证，在上述情况发生时，我们会要求披露请求方必须出具与之相应的有效法律文件，并对被披露的信息采取符合法律和业界标准的安全防护措施。"
  },
  {
    type: "titleAndcontext",
    title: "3.4 共享、转让、公开披露个人信息授权同意的例外",
    context:
      "根据相关法律法规的规定，在以下情形中，我们可以在不征得您的授权同意的情况下共享、转让、公开披露您的个人信息：<br/>A. 与国家安全、国防安全有关的；<br/>B. 与公共安全、公共卫生、重大公共利益有关的；<br/>C. 与犯罪侦查、起诉、审判和判决执行等有关的；<br/>D. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br/>E. 您自行向社会公众公开的个人信息；<br/>F. 从合法公开披露的信息中收集到的个人信息的，如合法的新闻报道、政府信息公开等渠道。<br/>G. 法律法规规定的其他情形。<br/>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。"
  },
  {
    type: "titleAndcontext",
    title: "4．我们如何保护您的个人信息",
    context:
      "您的个人信息安全对于我们至关重要。我们将严格遵守相关法律法规，采取业内认可的合理可行的措施，保护您的个人信息。防止信息遭到未经授权的访问、披露、使用、修改，避免信息损坏或丢失。"
  },
  {
    type: "titleAndcontext",
    title: "5. 如何管理您的信息",
    context: ""
  },
  {
    type: "titleAndcontext",
    title: "5.1 访问、更新和删除",
    context:
      "我们鼓励您更新和修改您的信息使其更精确有效。您能通过MPai访问您的信息，并根据对应信息的管理方式自行完成或要求我们进行修改、补充和删除。我们将采取适当的技术手段或提供提交申请的联系渠道，尽可能保证您可以访问、更新和更正自己的信息或使用MPai时提供的其他信息。如您想查询、修改或删除您的部分信息，请登录MPai进行相关操作，或者通过本隐私政策中载明的联系方式联系我们进行处理。"
  },
  {
    type: "context",
    context:
      "在访问、更新、和删除前述信息时，我们可能会要求您进行身份验证，以保障信息安全。对于通过Cookie或同类技术收集您的信息，我们还在本《隐私政策》第六条“我们如何使用Cookie同类技术”部分说明了向您提供的选择机制。"
  },
  {
    type: "context",
    context:
      "除法律法规另有规定，当您更正、删除您的个人信息或申请注销账号时，我们可能不会立即从备份系统中更正或删除相应的信息，但会在备份更新时更正或删除这些信息。"
  },
  {
    type: "titleAndcontext",
    title: "5.2 改变您授权同意的范围",
    context:
      "您总是可以选择是否披露信息。有些信息是使用MPai所必须的，但大多数其他信息的提供是由您觉决定的。您可以通过删除信息等方式改变您授权我们收集信息的范围或撤回您的授权。"
  },
  {
    type: "context",
    context:
      "当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。"
  },
  {
    type: "titleAndcontext",
    title: "6. 我们如何使用Cookie或同类技术",
    context:
      "您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务/产品质量及优化用户体验。如您不希望个人信息保存在 Cookie 中，您可对浏览器进行配置，选择禁用 Cookie 功能。禁用 Cookie 功能后，可能影响您访问MPai或不能充分取得MPai提供的服务。<br/>我们不会将 Cookie 用于本指引所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。"
  },
  {
    type: "titleAndcontext",
    title: "7. 未成年人保护",
    context:
      "7.1 MPai服务主要面向成人。我们的产品、网站和服务主要面向成人。若您是 18 周岁以下的未成年人，在使用我们的产品或服务前，您应在监护人的陪同下阅读本指引，并应确保已征得您的监护人同意后使用我们的服务并向我们提供您的信息。我们会根据国家相关法律法规的规定着重保护未成年人的个人信息。<br/>7.2 如您的监护人不同意您按照本指引使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们。<br/>7.3 对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。<br/>7.4 若您是未成年人的监护人，当您对您所监护的未成年人使用我们的服务或其向我们提供的用户信息有任何疑问时，请您及时与我们联系。我们将根据国家相关法律法规及本指引的规定保护未成年人用户信息的保密性及安全性。如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。"
  },
  {
    type: "titleAndcontext",
    title: "8. 通知与修订",
    context: ""
  },
  {
    type: "titleAndcontext",
    title: "",
    subTitle:
      "8.1 我们可能适时修改本政策的条款，该等修改构成本政策的一部分。我们会在MPai内发出本《隐私政策》的更新版本，或以其他适当的方式提醒您相关内容的更新",
    context: ""
  },
  {
    type: "titleAndcontext",
    title: "",
    subTitle:
      "8.2 我们可能在必须时发出与服务相关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。",
    context: ""
  },
  {
    type: "titleAndcontext",
    title: "9．联系我们",
    subTitle: "",
    context:
      "如您有关于网络信息安全的投诉和举报，或您对本《隐私政策》、您的信息相关事宜有任何问题、意见或建议，以及有关本《隐私政策》或MPai的隐私措施的问题，请随时与我们联系，可发送电子邮件至support@willingdata.com咨询。"
  },
  {
    type: "context",
    context:
      "一般情况下，我们将在收到您的问题、意见或建议，并验证您的用户身份后三十天内予以回复。"
  }
];
